import { render } from "./TermsShindo.vue?vue&type=template&id=fe6a7668&ts=true"
import script from "./TermsShindo.vue?vue&type=script&lang=ts"
export * from "./TermsShindo.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__